import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PageContainer from '../../components/container/PageContainer';
import { Box, Grid, TextField, Typography, Stack, IconButton, card, Card, Snackbar } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import AddBoxIcon from '@material-ui/icons/AddBox';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './Quill.css';
import {
  MobileDatePicker,
  LocalizationProvider,
  DateTimePicker,
  TimePicker,
} from '@material-ui/lab';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import CustomTextField from '../../components/forms/custom-elements/CustomTextField';

import { saveCapsule, updateCapsuleCount } from '../../actions/capsuleActions';
import * as types from '../../redux/constants/index';

export default function Capsule() {
  const [text, setText] = useState("");
  const [title, setTitle] = useState("Untitled");
  const [date, setDate] = useState(new Date());
  const [shouldOpenSnackbar, setShouldOpenSnackbar] = useState(false);
  const dispatch = useDispatch();
  const capsule = useSelector(state => state.Capsule.currentCapsule);

  const onTitleChange = (event) => {
    setTitle(event.target.value);
  }

  const onSaveButtonClicked = (event) => {
    const data = {
      text,
      title,
      capsule,
      targetDate: date.getTime()
    }

    dispatch(saveCapsule(data));

    //display snackbar notification
    setShouldOpenSnackbar(true);
  }

  const onNewButtonClicked = () => {
    dispatch({
      type: types.CLEAR_CAPSULE,
    })

    setText("");
    setTitle("Untitled");
    setDate(new Date);
  }

  /* Updates the editor state upon recieving new/newer capsule object.
      also updates the capsule count.*/
  useEffect(() => {

    if (capsule) {
      setText(capsule.content);
      setTitle(capsule.title);
      setDate(new Date(capsule.date_target))
    }

    //update count
    dispatch(updateCapsuleCount);
  }, [capsule])

  return (
    <PageContainer title="Capsule" description="This is where you create and edit Capsules.">
      <Snackbar open={shouldOpenSnackbar} autoHideDuration={2000} message="Saved" onClose={setShouldOpenSnackbar} />
      <Grid container>
        <Grid container sx={{ marginBottom: 1 }} >
          <Grid id="title-container" container item xs={10} alignItems="center" >
            <TextField id="standard-basic" label="Enter Title" variant="standard" fullWidth value={title} onChange={onTitleChange} />
          </Grid>
          <Grid id="icon-container" container item xs={2} alignItems="flex-end" justifyContent="flex-end" >
            <Stack direction="row" spacing={1} >
              <IconButton onClick={onNewButtonClicked}>
                <AddBoxIcon />
              </IconButton>
              <IconButton aria-label="save" onClick={onSaveButtonClicked}>
                <SaveIcon />
              </IconButton>
              <IconButton aria-label="change date">
                <CalendarTodayIcon />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>
        <Grid id="date-container" item xs={12}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
              placeholder="Start date"
              onChange={setDate}
              renderInput={(inputProps) => (
                <TextField
                  variant="standard"
                  size="small"
                  inputProps={{ 'aria-label': 'basic date picker' }}
                  {...inputProps}
                />
              )}
              value={date}
            />
          </LocalizationProvider>
        </Grid>
        <Grid id="quill-container" item xs={12}>
          <Card sx={{ marginLeft: 0 }}>
            <ReactQuill value={text} onChange={setText} />
          </Card>
        </Grid>
      </Grid>
    </PageContainer>
  );
}


